<template>
  <p class="text" :class="{ '-open': isOpen }">
    {{ outputText }}
    <button v-if="!isOpen" @click="isOpen = true" class="text_more">
      もっと見る
    </button>
  </p>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from '@vue/runtime-core'

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true
    },
    cropLength: {
      type: Number,
      default: 100
    }
  },

  setup(props) {
    const isOpen = ref(props.text.length <= props.cropLength)

    const outputText = computed(() => {
      if (isOpen.value) return props.text

      return props.text.substring(0, props.cropLength) + '…'
    })

    return {
      isOpen,
      outputText
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.text {
  &.-open {
    white-space: pre-line;
  }

  &_more {
    color: var.$color-main-text;
  }
}
</style>
